import React from 'react';
import {connect} from 'react-redux';
import resolvePath from '../../../misc/resolvePath';
import Blocklink from '../../elements/Blocklink/Blocklink';
import {dialogAlert} from '../../elements/Dialog/dialogs';
import Input from '../../elements/forms/Input';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Validate from '../../validate/Validate';
import Screen from '../Screen';

export class DirectoryMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: '',
            message: '',
        };
    }
    render() {
        let {event, item, i18n} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event} />
                    <hr />
                </div>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="content">
                            <Input type="text" label={i18n['label.subject']} value={this.state.subject} onChange={this.handleChange.bind(this, 'subject')} />
                            <Input
                                type="textarea"
                                label={i18n['label.message']}
                                rows="5"
                                value={this.state.message}
                                onChange={this.handleChange.bind(this, 'message')}
                            />
                        </div>
                        <Blocklink right next type="submit" customColor={event.settings.primary_color}>
                            {i18n['label.submit']}
                        </Blocklink>
                    </form>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({[field]: value});
    }
    async handleSubmit(e) {
        e.preventDefault();

        var subject = this.state.subject.trim(),
            message = this.state.message.trim();

        if (!subject.length) {
            await dialogAlert(this.props.i18n["label.subject.field.can't.be.empty"]);
        } else if (!message.length) {
            await dialogAlert(this.props.i18n["label.message.field.can't.be.empty"]);
        } else {
            app.api.events
                .sendMessageToSponsor(this.props.userId, this.props.item.id, subject, message)
                .then(async () => {
                    await dialogAlert(this.props.i18n['label.successfully.sent']);
                    app.history.push(resolvePath(location.pathname, '..'));
                })
                .catch(async err => {
                    console.warn(err);
                    await dialogAlert(this.props.i18n['label.message.not.send']);
                });
        }
    }
}

const ConnectedScreen = connect((state, props) => {
    let event = state.events[props.eventId].event;
    return {
        event,
        item: state.events[props.eventId].directory.all[props.itemId],
        i18n: state.i18n.translations,
        userId: state.session.user.id,
    };
})(DirectoryMessage);

export default props => {
    let path = (props.match.params.path || '').split('/'),
        items = path.map(n => parseInt(n)),
        itemId = parseInt(_.last(path)),
        parents = _.slice(path, 0, -1) || [];

    return (
        <Validate
            validate={state => {
                let eventId = props.match.params.eventId,
                    event = state.events[eventId].event;
                if (!state.events[props.match.params.eventId].directory.all[itemId]) {
                    throw new Error('Item not found: ' + itemId);
                }
            }}>
            <ConnectedScreen {...props.match.params} itemId={itemId} />
        </Validate>
    );
};
